<template>
  <div>
    <footer class="mt-3">
      <div class="container fG">
        <div class="row p-2 no-gutters">
          <div class="col-12 text-center">
           <img src="../assets/imgs/coca/walmart-coca-logo-footer.png" alt="Coca-Cola Walmart" class="img-fluid py-3">
          </div>
          <!-- <div class="col-12">
            <div class="texto gris text-right small">
              <router-link to="/" target="_blank">Términos y condiciones</router-link>
            </div>
          </div> -->
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{active: this.$store.state.loading}">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  name: "Footer",
  /*props: {
    msg: String
  }*/ data() {
    return {
      matriculaadmin: "",
      nombre: ""
    };
  },
  mounted: function() {
    
  },
  methods: {
    
  }
};
</script>

